import { PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import React, { useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { ExternalAPI } from '../../../../components/ExternalAPI';
import { ClassItemEdit } from './ClassItemEdit';
import { hooks, models } from '@vote4dance/judging-sdk';
var Stream = hooks.streams.Stream;
var ClassesSource = models.classes.ClassesSource;
export const ClassPageToolbar = (props) => {
    const { competition_id, disabled } = props;
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [classes] = Stream(ClassesSource(competition_id));
    const hasClasses = ((classes === null || classes === void 0 ? void 0 : classes.length) || 0) > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(Space, null,
            hasClasses &&
                React.createElement(Button, { key: "create", disabled: disabled, icon: React.createElement(PlusOutlined, null), onClick: () => setVisibleEdit(true) }, _T('common.add', { name: _T('class.title').toLowerCase() })),
            React.createElement(ExternalAPI, { competition_id: competition_id, mode: 'competition', disabled: disabled })),
        React.createElement(ClassItemEdit, { competition_id: competition_id, visible: visibleEdit, setVisible: setVisibleEdit })));
};
